export default __webpack_public_path__ + "static/media/ZUSAMMENKLAPPBARES-GLASSYSTEM.3777dde7.jpg";